<template>
  <v-app id="login" class="primary">
    <v-main class="login">
      <v-container fluid class="px-12">
        <v-row>
          <v-col class="left" cols="7">
            <v-row>
              <v-col cols="12" class="logo">
                <v-img width="234px" src="@/assets/logo/m_logo.png" />
                <span class="white--text f-14"
                  >The ultimate finance planner apps</span
                >
              </v-col>
              <v-col>
                <div style="height: 60vh"></div>
              </v-col>
              <v-col cols="12" class="powered">
                <span class="white--text f-12"><b>Powered by:</b></span>
                <v-img
                  class="mt-5"
                  width="91px"
                  src="@/assets/logo/gits_logo.png"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col class="right" cols="5">
            <v-container
              fluid
              class="pa-0"
              :class="{ 'fill-height': $vuetify.breakpoint.smAndUp }"
            >
              <v-row align="center" justify="center">
                <v-col cols="12" xs="12" sm="10" md="10" lg="8">
                  <v-card class="mt-0 card-login" raised>
                    <ValidationObserver ref="obs">
                      <!-- <v-alert
                        v-if="error && error.message"
                        class="ma-2"
                        type="error"
                        :value="true"
                        dismissible
                      >
                        {{ error.message }}
                      </v-alert> -->
                      <v-layout v-if="formLogin" row wrap class="mb-6">
                        <v-flex xs12 class="px-3">
                          <h2
                            class="
                              white--text
                              text-left
                              mb-4
                              font-weight-bold
                              title
                            "
                          >
                            Welcome!
                          </h2>
                          <span class="subtitle">Please Login First</span>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap class="mb-6" v-if="formProfile">
                        <v-flex xs12 class="px-3">
                          <h2
                            class="
                              white--text
                              text-left
                              mb-4
                              font-weight-bold
                              title
                            "
                          >
                            Welcome!
                          </h2>
                          <span class="subtitle">Please Select Profile</span>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap class="mb-6" v-if="formForgotPassword">
                        <v-flex xs12 class="px-3">
                          <span class="white--text title">Forgot Password</span>
                        </v-flex>
                      </v-layout>
                      <div v-if="formProfile">
                        <v-card-text class="pa-0">
                          <ValidationProvider
                            name="Profile"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <v-autocomplete
                              id="select-profile"
                              outlined
                              v-model="profile"
                              :items="items"
                              return-object
                              v-on:keyup.enter="submit()"
                              item-text="desc"
                              placeholder="Profile"
                              background-color="white"
                              dense
                              :error-messages="errors"
                              single-line
                            >
                            </v-autocomplete>
                          </ValidationProvider>
                        </v-card-text>
                        <v-card-actions class="pa-0">
                          <v-row>
                            <v-col cols="12">
                              <div class="pa-0 ma-0">
                                <v-btn
                                  id="btn-submit"
                                  right
                                  light
                                  block
                                  color="#28A0F6"
                                  class="white--text my-3 elevation-0"
                                  :loading="loading2"
                                  @click="submit()"
                                  height="38"
                                  min-height="38"
                                >
                                  Submit
                                </v-btn>
                              </div>

                              <div class="pa-0 ma-0 mt-3">
                                <v-btn
                                  v-if="!$route.query"
                                  id="btn-cancel"
                                  right
                                  light
                                  block
                                  color="#28A0F6"
                                  class="white--text"
                                  @click="backLogin()"
                                  height="38"
                                  min-height="38"
                                >
                                  Cancel
                                </v-btn>
                              </div>
                            </v-col>
                          </v-row>
                        </v-card-actions>
                      </div>
                      <div v-if="formLogin">
                        <v-card-text class="pa-0">
                          <v-text-field
                            id="email"
                            dense
                            outlined
                            color="#98A3B5"
                            prepend-inner-icon="ri-user-line"
                            name="email"
                            v-on:keyup.enter="login()"
                            type="text"
                            v-model="email"
                            background-color="white"
                            class="pa-0"
                            placeholder="Email"
                          >
                          </v-text-field>
                          <v-text-field
                            dense
                            outlined
                            :append-icon="
                              show1 ? 'ri-eye-line' : 'ri-eye-off-line'
                            "
                            prepend-inner-icon="ri-lock-line"
                            @click:append="show1 = !show1"
                            v-on:keyup.enter="login()"
                            :type="show1 ? 'text' : 'password'"
                            name="password"
                            id="password"
                            background-color="white"
                            v-model="password"
                            class="pa-0"
                            color="#98A3B5"
                            placeholder="Password"
                          >
                          </v-text-field>
                          <v-layout row wrap class="px-3">
                            <v-flex xs6>
                              <!-- <v-checkbox
                                id="remember"
                                v-model="checkbox"
                                class="pa-0 ma-0"
                                color="white"
                              >
                                <template v-slot:label>
                                  <div
                                    class="white--text f-12"
                                    style="margin-left:-10px"
                                  >
                                    Remember Me
                                  </div>
                                </template>
                              </v-checkbox> -->
                              <div class="round">
                                <input
                                  v-model="checkbox"
                                  type="checkbox"
                                  id="checkbox"
                                />
                                <label for="checkbox" class="mt-1"></label>
                                <span
                                  class="white--text f-12 ml-3"
                                  style="margin-top: -5px"
                                >
                                  Remember Me
                                </span>
                              </div>
                            </v-flex>
                            <v-flex xs6 class="text-right">
                              <a
                                id="forgot"
                                class="white--text f-12"
                                @click="forgotPassword()"
                              >
                                Forgot Password?
                              </a>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                        <v-card-actions class="pa-0 mt-2 mb-3">
                          <v-flex xs12 class="pa-0">
                            <v-btn
                              id="btn-login"
                              right
                              light
                              block
                              color="#28A0F6"
                              @click="login()"
                              class="white--text my-3 elevation-0"
                              :loading="loading"
                              height="48"
                              min-height="48"
                            >
                              Login
                            </v-btn>
                          </v-flex>
                        </v-card-actions>
                      </div>
                      <div v-if="formForgotPassword">
                        <v-card-text class="pa-0">
                          <h5
                            class="text-left font-weight-medium mb-5 subtitle-2"
                          >
                            Please input your email address. We will send you
                            instructions to reset your password.
                          </h5>
                          <v-text-field
                            id="email"
                            single-line
                            dense
                            outlined
                            background-color="white"
                            v-on:keyup.enter="resetPass()"
                            prepend-inner-icon="person"
                            name="email"
                            placeholder="Email"
                            type="text"
                            v-model="emailForgot"
                            class="pa-0"
                          >
                          </v-text-field>
                        </v-card-text>
                        <v-flex xs12 class="pa-0">
                          <v-btn
                            id="btn-login"
                            right
                            light
                            block
                            color="#28A0F6"
                            class="white--text f-12 mb-2"
                            :loading="loading3"
                            @click="resetPass()"
                            height="38"
                            min-height="38"
                          >
                            SUBMIT
                          </v-btn>
                        </v-flex>
                        <v-flex xs12 class="pa-0">
                          <v-btn
                            id="btn-login"
                            right
                            light
                            block
                            color="blueCloud"
                            class="white--text f-12"
                            :loading="loading"
                            @click="backLogin()"
                            height="38"
                            min-height="38"
                          >
                            Cancel
                          </v-btn>
                        </v-flex>
                      </div>
                    </ValidationObserver>
                  </v-card>
                </v-col>
                <v-col cols="12" class="pt-3 copyright">
                  <h5 class="white--text font-weight-medium text-center f-12">
                    Copyright © 2022 GITS Indonesia.
                  </h5>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <v-dialog v-model="modalChangePassword" persistent max-width="400px">
      <v-card>
        <v-card-title class="primary white--text">
          <span class="pa-0">Change Password</span>
        </v-card-title>
        <v-card-text class="pa-5">
          <ValidationObserver ref="changePassword">
            <v-container class="py-0">
              <v-row>
                <v-col cols="12" class="pa-0">
                  <p class="grey--text text--darken-3">
                    Hi, {{ name }}! Your current password is expired, please
                    change your password.
                  </p>
                  <ValidationProvider
                    name="Current Password"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      single-line
                      outlined
                      dense
                      :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="show2 = !show2"
                      :type="show2 ? 'text' : 'password'"
                      name="Current Password"
                      placeholder="Current Password"
                      id="current-password"
                      v-model="current_password"
                      background-color="white"
                      class="pa-0"
                      :error-messages="errors"
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" class="pa-0">
                  <ValidationProvider
                    name="New Password"
                    vid="confirm"
                    rules="required|min:8"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      single-line
                      dense
                      outlined
                      :append-icon="show3 ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="show3 = !show3"
                      :type="show3 ? 'text' : 'password'"
                      name="New Password"
                      placeholder="New Password"
                      id="new-password"
                      background-color="white"
                      v-model="new_password"
                      class="pa-0"
                      :error-messages="errors"
                      hint="At least 8 characters"
                      counter
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" class="pa-0">
                  <ValidationProvider
                    name="Confirm Password"
                    rules="required|confirmed:confirm|min:8"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      single-line
                      outlined
                      dense
                      :append-icon="show4 ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="show4 = !show4"
                      :type="show4 ? 'text' : 'password'"
                      name="Confirm Password"
                      placeholder="Confirm Password"
                      id="confirm-password"
                      v-model="confirm_password"
                      background-color="white"
                      class="pa-0"
                      :error-messages="errors"
                      hint="At least 8 characters"
                      counter
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <label
                  class="red--text"
                  style="font-size: 10px; line-height: 1.5em !important"
                  >*Password must be minimum 8 characters and consist an
                  uppercase, lowercase, special character, and number</label
                >
              </v-row>
            </v-container>
          </ValidationObserver>
        </v-card-text>
        <v-card-actions class="pb-3 px-6">
          <v-spacer></v-spacer>
          <v-btn color="#bd1e19" dark @click="modalChangePassword = false">
            Close
          </v-btn>
          <v-btn
            color="primary"
            dark
            @click="changePassword()"
            :loading="loadingChange"
          >
            Submit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import Swal from 'sweetalert2';
import ACLMixin from '../../mixins/ACLMixin';

export default {
  mixins: [ACLMixin],
  data: () => ({
    isLogin: false,
    loading: false,
    loading2: false,
    loading3: false,
    loadingChange: false,
    email: '',
    emailForgot: '',
    password: '',
    formLogin: true,
    formProfile: false,
    checkbox: false,
    items: [],
    profile: null,
    show1: false,
    show2: false,
    show3: false,
    show4: false,
    formForgotPassword: false,
    isCompability: false,
    modalChangePassword: false,
    name: '',
    new_password: '',
    current_password: '',
    confirm_password: ''
  }),
  computed: {
    nextUri() {
      return this.$route.query.next || '/';
    }
  },
  mounted() {
    // localStorage.clear();
    if ('token' in this.$route.query) {
      this.loginOptima();
      localStorage.setItem('iv', this.$route.query.iv);
    }
  },
  methods: {
    async loginOptima() {
      let params = {
        token: this.$route.query.token
      };
      this.$store
        .dispatch('auth/loginOptima', params)
        .then(data => {
          if (data.data.code === 200) {
            this.items = data.data.data.profiles;
            this.formLogin = false;
            this.formProfile = true;
            this.loading = false;
          } else {
            Swal.fire(
              'Failed',
              'Failed to Login! Please try again later',
              'error'
            );
          }
        })
        .catch(err => {
          this.loading = false;
          Swal.fire('Login Failed', err.response.data.message.text_en, 'error');
        });
    },
    async login() {
      if (!this.email) {
        Swal.fire('Email must be filled!');
      } else if (!this.password) {
        Swal.fire('Password must be filled!');
      } else {
        this.loading = true;
        let params = {
          email: this.email.trim(),
          password: this.password
        };
        this.$store
          .dispatch('auth/login', params)
          .then(data => {
            if (data.data.code === 200) {
              // this.getProfile();
              // this.$router.push({ name: 'dashboard' });
              this.compabilityCheck();
              this.items = data.data.data.profiles;
              // this.isLogin = true;
              // this.loading = false;
            } else {
              Swal.fire(
                'Failed',
                'Failed to Login! Please try again later',
                'error'
              );
              this.loading = false;
              this.formLogin = true;
              this.formProfile = false;
            }
          })
          .catch(err => {
            this.loading = false;
            Swal.fire(
              'Login Failed',
              err.response.data.message.text_en,
              'error'
            );
          });
      }
    },
    async compabilityCheck() {
      this.loading = true;
      return await this.$store
        .dispatch('auth/getCompabilityCheck')
        .then(data => {
          if (data.code === 200) {
            this.isCompability = data.data.status === 'ok' ? true : false;
            if (this.isCompability) {
              this.formLogin = false;
              this.formProfile = true;
              this.loading = false;
            } else {
              this.name = localStorage.getItem('name');
              this.loading = false;
              this.modalChangePassword = true;
            }
          } else {
            this.loading = false;
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.progressDialogLoading = false;
          this.loading = false;
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    submit() {
      this.loading2 = true;
      if (this.profile) {
        localStorage.setItem('userProfile', JSON.stringify(this.profile));
        localStorage.setItem('profile_id', JSON.stringify(this.profile.id));
        const params = {
          profile_id: this.profile.id
        };
        this.$store
          .dispatch('auth/getRoleConfig', params)
          .then(data => {
            this.loading2 = false;
            if (data.code === 200) {
              localStorage.setItem(
                'userRole',
                JSON.stringify(data.data.mapping)
              );
              if (this.profile && this.profile.desc === 'SSHCF') {
                this.$router.push({ name: 'sshcf_dashboard' });
              } else if (this.profile && this.profile.desc.includes('SSHCP')) {
                this.$router.push({ name: 'sshcp_dashboard' });
              } else if (this.hasPermission('finance_portal_view', 'view')) {
                this.$router.push({ name: 'financial-portal' });
              } else {
                this.$router.push({ name: 'dashboard' });
              }
            } else {
              Swal.fire('Failed!', data.response.data.data.error, 'error');
            }
          })
          .catch(err => {
            this.loading2 = false;
            Swal.fire('Failed!', err.response.data.data.text_en, 'error');
          });
      } else {
        this.loading2 = false;
      }
    },
    resetPass() {
      this.loading3 = true;
      let params = {
        email: this.emailForgot.trim()
      };
      this.$store
        .dispatch('auth/resetPassword', params)
        .then(data => {
          this.loading3 = false;
          if (data.code === 200) {
            if (data.data === 'Successfuly forgot password!') {
              Swal.fire(
                'Success!',
                'Email for reset password wil be sent. Please wait.',
                'success'
              );
            } else {
              Swal.fire('Failed!', data.message.text_en, 'error');
            }
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(error => {
          this.loading3 = false;
          Swal.fire(
            'Email Failed to Send',
            error.response.data.message.text_en,
            'error'
          );
        });
    },
    backLogin() {
      this.formLogin = true;
      this.formProfile = false;
      this.formForgotPassword = false;
    },
    forgotPassword() {
      this.formForgotPassword = true;
      this.formProfile = false;
      this.formLogin = false;
    },
    showChangePassword() {
      this.current_password = '';
      this.new_password = '';
      this.confirm_password = '';
      requestAnimationFrame(() => {
        this.$refs.changePassword.reset();
      });
      this.modalChangePassword = true;
    },
    changePassword() {
      this.loadingChange = true;
      if (this.new_password === this.confirm_password) {
        this.loadingChange = true;
        let params = {
          currentPassword: this.current_password,
          newPassword: this.new_password
        };
        this.$store
          .dispatch('auth/changePassword', params)
          .then(data => {
            this.progressDialogLoading = false;
            if (data.code === 200) {
              this.loadingChange = false;
              this.modalChangePassword = false;
              Swal.fire({
                title: 'Success!',
                text: `${data.message.text_en}`,
                type: 'success',
                showCancelButton: false,
                confirmButtonText: 'OK'
              }).then(result => {
                if (result.value) {
                  this.logout();
                  this.email = '';
                  this.password = '';
                }
              });
            } else {
              this.loadingChange = false;
              Swal.fire('Failed!', data.response.data.message.text_en, 'error');
            }
          })
          .catch(err => {
            this.loadingChange = false;
            this.progressDialogLoading = false;
            Swal.fire('Failed!', err.response.data.data.text_en, 'error');
          });
      } else {
        this.loadingChange = false;
        Swal.fire(
          'Failed!',
          'Password Confirmation did not match. Please check and try again.',
          'error'
        );
      }
    },
    async logout() {
      await this.$store.dispatch('auth/logout');
      localStorage.clear();
      this.$router.push({
        name: 'login'
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
.login {
  // height: 100%;
  // width: 100%;
  // position: absolute;
  background-image: url('../../assets/bg/bg_nav_core.png');
  -webkit-background-size: 100% 100%;
  -moz-background-size: 100% 100%;
  -o-background-size: 100% 100%;
  background-size: 100% 100%;
  // top: 0;
  // left: 0;
  // content: '';
  // z-index: 0;
}
.powered span {
  opacity: 0.5;
}
.logo span {
  opacity: 0.5;
}
.line {
  border: 1px solid #dadada;
}
.rememberme--text {
  color: red !important;
  font-size: 100px;
}
.card-login {
  background: transparent !important;
  box-shadow: none !important;
}
.card-login .title {
  font-size: 32px !important;
  font-family: 'Poppins';
  letter-spacing: -0.02em;
  line-height: 100%;
}
.card-login .subtitle {
  font-size: 18px !important;
  color: rgba(255, 255, 255, 0.36) !important;
  font-weight: bold;
  line-height: 100%;
  letter-spacing: -0.02em;
}
.subtitle-2 {
  font-size: 12px !important;
  color: rgba(255, 255, 255, 0.721) !important;
  line-height: 100%;
  letter-spacing: -0.02em;
}
.round {
  position: relative;
}

.round label {
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  height: 15px;
  left: 0;
  position: absolute;
  top: 0;
  width: 15px;
}

.round label:after {
  border: 2px solid #5273e8;
  border-top: none;
  border-right: none;
  content: '';
  height: 4px;
  left: 3px;
  opacity: 0;
  position: absolute;
  top: 4px;
  transform: rotate(-45deg);
  width: 7px;
}

.round input[type='checkbox'] {
  visibility: hidden;
}
.round input[type='checkbox']:checked + label {
  background-color: #fff;
  border-color: #ccd6e6;
}
.round input[type='checkbox']:checked + label:after {
  opacity: 1;
}
.copyright h5 {
  position: absolute;
  padding-top: 8%;
  right: 10.5%;
}
</style>
